module.exports = __webpack_public_path__ + "img/galeria-insectos-4.8df81f95.jpg";